<template>
  <WorkCrews v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import WorkCrews from "./WorkCrews.vue";

export interface TDepartment {
  name: string;
  id: number;
}

export interface TLink {
  crew_member_create: string;
  crew_member_unassign_all: string;
}

const initialData = ref<{
  department: TDepartment;
  links: TLink;
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>

<style scoped></style>
